// extracted by mini-css-extract-plugin
export default {"home":"Home_home__MJf3q","card":"Home_card__K4FV1"};